import { render, staticRenderFns } from "./neutral.vue?vue&type=template&id=513f8b8b&scoped=true&"
import script from "./neutral.vue?vue&type=script&lang=js&"
export * from "./neutral.vue?vue&type=script&lang=js&"
import style0 from "./neutral.vue?vue&type=style&index=0&id=513f8b8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f8b8b",
  null
  
)

export default component.exports